module.exports = __webpack_public_path__ + "static/media/b2-entranc-mobile.665e3f2c.webp";